import { connect } from 'react-redux';
import View from './DebtManagementChartView';
import MobileView from './MobileDebtManagementChartView';
import * as debtManagementChartSelector from './DebtManagementChartSelector';
import {
  getGoalsChartList,
  resetState,
 } from './DebtManagementChartActions';

import { selectedPlanNameSelector, currentPlanNameSelector, isCurrentPlanSelector } from '../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';

const mapStateToProps = (state, props) => ({
  isCurrent: isCurrentPlanSelector(state, props),
  chartData: debtManagementChartSelector.goalChartPopulated(state, props),
  chartTitle: debtManagementChartSelector.chartTitle(state, props),
  dataIsOutdated: debtManagementChartSelector.dataIsOutdated(state, props),
  fpId: debtManagementChartSelector.fpId(state, props),
  goalId: debtManagementChartSelector.goalId(state, props),
  hasChartData: debtManagementChartSelector.hasChartData(state, props),
  hasLoaded: debtManagementChartSelector.hasLoaded(state, props),
  isPdf: debtManagementChartSelector.isPdf(state, props),
  isPrint: debtManagementChartSelector.isPrint(state, props),
  selectedPlanName: selectedPlanNameSelector(state, props),
  currentPlanName: currentPlanNameSelector(state, props),
});

const mapDispatchToProps = dispatch => ({
  getChartData: (fpId, clientId, goalId, isPdf) => (
    dispatch(getGoalsChartList(fpId, clientId, goalId, isPdf))
  ),
  resetState: () => (
    dispatch(resetState())
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileDebtManagementChart = connect(mapStateToProps, mapDispatchToProps)(MobileView);
